<kz-modal-header>
  <h1 class="kz-section-title kz-section-title--decorator"><span i18n="@@pro.tender.modal.title">Specify your project</span></h1>
</kz-modal-header>
<kz-modal-content>
  <form
    class="kz-pro-tender-form--form"
    [formGroup]="proTenderForm">
    <kz-field [hasError]="isFieldInvalid('title')">
      <label kzLabel for="kz-tender--title" i18n="@@pro.tender.form.project.label" isRequired="true">Describe your need</label>
      <ng-select formControlName="title" name="title" id="kz-tender--title"
                 [placeholder]="placeholder"
                 [addTag]="true"
                 [addTagText]="add"
                 [clearable]="false">
        <ng-option *ngFor="let project of tenderProjects;" [value]="project">{{ project }}</ng-option>
      </ng-select>
      <p *ngIf="isFieldInvalid('title') && proTenderForm.get('title').errors?.required" kzError><span i18n="@@pro.tender.form.required">Required</span></p>
    </kz-field>

    <kz-field [hasError]="isFieldInvalid('phoneNumber')">
      <label id="phoneNumber" kzLabel for="kz-tender--phoneNumber" i18n="@@pro.tender.phoneNumber.label" isRequired="true">Phone number</label>
      <app-phone-code id="kz-tender--mobile" [countryPhoneCode]="33"
                      [paddingVersion]="2"
                      (selectedCode)="codeSelected=$event.phoneCode; !$event.firstTime && proTenderForm.get('phoneNumber').markAsDirty(); !$event.firstTime && proTenderForm.get('phoneNumber').markAsTouched();"></app-phone-code>
      <input kzTextBox formControlName="phoneNumber" name="phoneNumber" id="kz-tender--phoneNumber" type="phone"
             i18n-placeholder="@@pro.tender.form.phoneNumber.placeholder"
             required
             placeholder="In order to facilitate exchanges with Kozikaza"/>
      <p *ngIf="isFieldInvalid('phoneNumber') && proTenderForm.get('phoneNumber').errors?.required" kzError i18n="@@pro.tender.form.errors.required">Required</p>
      <p *ngIf="proTenderForm.get('phoneNumber').dirty && proTenderForm.get('phoneNumber').errors?.pattern" kzError i18n="@@pro.tender.form.errors.phoneNumber.valid">Phone number must be valid</p>
      <p *ngIf="proTenderForm.get('phoneNumber').dirty && proTenderForm.get('phoneNumber').errors?.maxlength" kzError i18n="@@pro.tender.form.errors.phoneNumber.maxlength">Phone number max length 15 Characters</p>
      <p *ngIf="proTenderForm.get('phoneNumber').errors?.apiError" kzError>{{proTenderForm.get('phoneNumber').errors?.apiError}}</p>
    </kz-field>

    <kz-field [hasError]="isFieldInvalid('description')">
      <label kzLabel isRequired="true" for="kz-tender--description" i18n="@@pro.tender.form.description.label">Description</label>
      <textarea kzTextBox formControlName="description" name="description" class="kz-textarea" id="kz-tender--description"
                i18n-placeholder="@@pro.tender.form.description.placeholder"
                placeholder="Describe your project as precisely as possible so that we can offer you the most suitable professionals for your project."></textarea>
      <p *ngIf="isFieldInvalid('description') && proTenderForm.get('description').errors?.required" kzError i18n="@@pro.tender.form.errors.required">Required</p>
      <p *ngIf="isFieldInvalid('description') && proTenderForm.get('description').errors?.apiError" kzError>{{proTenderForm.get('description').errors?.apiError}}</p>
    </kz-field>


    <kz-field *ngIf="showServiceLocation" formGroupName="serviceLocation" [hasError]="proTenderForm.get('serviceLocation').dirty && proTenderForm.get('serviceLocation').errors?.requireCheckboxToBeChecked">
      <label kzLabel i18n="@@pro.tender.form.serviceLocation.label" isRequired="true">You prefer</label>
      <kz-field absErrorMsg="true">
        <input kzCheckBox type="checkbox" formControlName="serviceDistance" id="kz-tender--serviceDistance"/>
        <label kzLabel for="kz-tender--serviceDistance" i18n="@@pro.tender.form.serviceDistance.label">Remotely (Kozikaza messaging, video, telephone, etc.)</label>
      </kz-field>
      <kz-field absErrorMsg="true" >
        <input kzCheckBox type="checkbox" formControlName="serviceAtHome" id="kz-tender--serviceAtHome"/>
        <label kzLabel for="kz-tender--serviceAtHome" i18n="@@pro.tender.form.serviceAtHome.label">A service at your home</label>
      </kz-field>

      <kz-field
        [hasError]="proTenderForm.get('city').dirty && proTenderForm.get('city').errors?.required"
        *ngIf="!!proTenderForm.get('serviceLocation')?.get('serviceAtHome')?.value">
        <input
          appAutocompleteOff
          kzTextBox
          class="kz-textbox--bordered"
          type="text"
          placeholder="Please enter a location"
          i18n-placeholder="@@kazacafe.explore.popin.geoloc"
          [value]="selectedAddress"
          (focus)="selectAllContent($event)"
          (mouseup)="$event.preventDefault()"
          appGooglePlaceAutocomplete
          (onSelect)="onAddressSelected($event)"
          (blur)="onBlur($event)"
        >
        <div class="kz-field-prefix"><kz-icons name="compass"></kz-icons></div>
        <div class="kz-field-suffix" (click)="geolocateMe()">
          <kz-icons name="crosshair"></kz-icons>
          <div i18n="@@pro.tender.form.geolocateMe">Geolocate me</div>
        </div>
      </kz-field>
      <p *ngIf="proTenderForm.get('serviceLocation').dirty && proTenderForm.get('serviceLocation').errors?.requireCheckboxToBeChecked" kzError i18n="@@pro.tender.form.errors.required">Required</p>
    </kz-field>
  </form>
</kz-modal-content>
<kz-modal-footer>
  <button type="button" (click)="cancel()" kzButton buttonStyle="borderless" [disabled]="submitted" data-cy="cancelTender"><span i18n="@@pro.tender.modal.cancel">Cancel</span></button>
  <button type="submit" (click)="onSubmit()" appGtmTrack="offer_tenders_form_sendrequest" kzButton buttonStyle="flat" [buttonState]="submitted ? 'loading' : 'default'" [disabled]="submitted || !proTenderForm.valid" data-cy="submitTender"><span i18n="@@pro.tender.modal.submit">Send request</span></button>
</kz-modal-footer>

